module.exports = "// Ready status\n<RefreshIndicator percentage={30} size={40} left={10} top={5} status=\"ready\" />\n<RefreshIndicator percentage={60} size={40} left={10} top={5} status=\"ready\" />\n<RefreshIndicator percentage={80} size={40} left={10} top={5}\n    color={\"red\"} status=\"ready\" />\n<RefreshIndicator percentage={100} size={40} left={10} top={5} status=\"ready\" />\n// Loading status\n<RefreshIndicator size={40} left={80} top={5} status=\"loading\" />\n<RefreshIndicator size={40} left={80} top={5} loadingColor={\"#FF9800\"} status=\"loading\" />\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/refresh-indicator-code.txt
 ** module id = 843
 ** module chunks = 0
 **/